import { NavLink } from 'react-router-dom';
import { Menu } from './menu';

export function Navbar() {
  return (
    <header className="sticky top-0 !z-50 w-full bg-background/95 shadow backdrop-blur supports-[backdrop-filter]:bg-background/60 dark:shadow-secondary">
      <div className="mx-4 flex h-14 items-center">
        <div className="flex items-center gap-1">
          <NavLink
            to="/"
            className={({ isActive }) =>
              `text-sm font-medium px-3 py-1.5 rounded-md hover:bg-muted ${
                isActive ? 'bg-muted' : ''
              }`
            }
          >
            Asosiy
          </NavLink>
          <NavLink
            to="/lesson-schedule"
            className={({ isActive }) =>
              `text-sm font-medium px-3 py-1.5 rounded-md hover:bg-muted ${
                isActive ? 'bg-muted' : ''
              }`
            }
          >
            Dars jadvali
          </NavLink>
          <NavLink
            to="/groups"
            className={({ isActive }) =>
              `text-sm font-medium px-3 py-1.5 rounded-md hover:bg-muted ${
                isActive ? 'bg-muted' : ''
              }`
            }
          >
            Guruhlarim
          </NavLink>
        </div>
        <div className="flex flex-1 items-center justify-end gap-3">
          <Menu />
        </div>
      </div>
    </header>
  );
}
